<template>
  <div>
    <create-content-layout :title="'ویرایش محتوا'" :submitFunction="UpdateContent"></create-content-layout>
  </div>
</template>
<script>
import CreateContentLayout from "./CreateLayoutContent.vue";
import {mapActions} from 'vuex';

export default {
  name: "CreateContent",
  components: {CreateContentLayout},
  methods: {
    ...mapActions({
      UpdateContent: "Content/updateContent"
    })
  }
}
</script>